import { Box, Link, Typography } from "@mui/material";
import { StatusIcon } from "src/components";
import { ACTION_ITEM_STATUSES, Links } from "../../constants";
import { FeedItemDto } from "../../http";

interface IProps {
  feedItem: FeedItemDto;
}

const ActionItemStatusPropertyChange = (props: IProps) => {
  const status = ACTION_ITEM_STATUSES.find((x) => x.id === props.feedItem.propertyChange!.value);

  return (
    <Typography variant="caption" sx={{ alignItems: "center" }}>
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link> updated status to
      <Box component="span" sx={{ fontWeight: "bold", ml: "2px" }}>
        <StatusIcon status={status!} sx={{ position: "relative", top: "2px" }} fontSize="small" />
        <span> {status!.name}</span>
      </Box>
    </Typography>
  );
};

export { ActionItemStatusPropertyChange };
